import { useCallback } from 'react';
import { useNewBookingStore } from '../../../../../domain/booking/stores/useNewBookingsStore';
import { IParkingProductUpgrade } from '../../../../../domain/parking-product/models/IParkingProductUpgrade';

export function useToggleUpgrade() {
	const newBookingStore = useNewBookingStore();

	return useCallback(
		(upgrade: IParkingProductUpgrade, isSelected: boolean) => {
			if (isSelected) {
				newBookingStore.selectUpgrade(upgrade);
			} else {
				newBookingStore.removeUpgrade();
			}
		},
		[newBookingStore],
	);
}
